export { default } from '../entering/fade-in';
export type { FadeKeyframesMotionProps } from '../entering/fade-in';
